import type { ToastContentType } from "@/components/layout/toast/styled-toast";
import { BiError } from "react-icons/bi";
import { IoWarningOutline } from "react-icons/io5";
import { MdOutlineErrorOutline } from "react-icons/md";
import { IoIosInformationCircleOutline } from "react-icons/io";
import { FaCheck } from "react-icons/fa";

export const ToastIcon = ({ icon }: { icon: ToastContentType["status"] }) => {
  switch (icon) {
    case "success":
      return <FaCheck size={20} />;
    case "error":
      return <MdOutlineErrorOutline size={20} />;
    case "info":
      return <IoIosInformationCircleOutline size={20} />;
    case "warning":
      return <IoWarningOutline size={20} />;
    default:
      return "";
  }
};
